module.exports = __webpack_public_path__ + "static/media/icon-orders.9a345113.svg";